<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<a id="title14"></a>
<div class="toc_entry"><a class="toc_entry_frontMatter" href="#/9781459262812_fm02"><span>Letter to Reader</span></a><br/>
<a class="toc_entry_titlePage" href="#/9781459262812_tp01"><span>Title Page</span></a><br/>
<a class="toc_entry_dedicationPage" href="#/9781459262812_ded01"><span>Dedication</span></a><br/>
<a class="toc_entry_chapter" href="#/9781459262812_c01"><span><strong class="b">CHAPTER ONE</strong></span></a><br/>
<span class="toc_entry_chapter" href="#/9781459262812_c02" title="Link target outside of Sample"><span><strong class="b">CHAPTER TWO</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459262812_c03" title="Link target outside of Sample"><span><strong class="b">CHAPTER THREE</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459262812_c04" title="Link target outside of Sample"><span><strong class="b">CHAPTER FOUR</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459262812_c05" title="Link target outside of Sample"><span><strong class="b">CHAPTER FIVE</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459262812_c06" title="Link target outside of Sample"><span><strong class="b">CHAPTER SIX</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459262812_c07" title="Link target outside of Sample"><span><strong class="b">CHAPTER SEVEN</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459262812_c08" title="Link target outside of Sample"><span><strong class="b">CHAPTER EIGHT</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459262812_c09" title="Link target outside of Sample"><span><strong class="b">CHAPTER NINE</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459262812_c10" title="Link target outside of Sample"><span><strong class="b">CHAPTER TEN</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459262812_c11" title="Link target outside of Sample"><span><strong class="b">CHAPTER ELEVEN</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/9781459262812_c12" title="Link target outside of Sample"><span><strong class="b">CHAPTER TWELVE</strong></span></span><br/>
<span class="toc_entry_pubInfo" href="#/9781459262812_cop01" title="Link target outside of Sample"><span>Copyright</span></span><br/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781459262812_toc01.vue?a1b2db50